export const ROLE = {
  ISSUE_TYPE_MANAGER: 'issue-type-manager',
  CREATOR: 'creator',
  OWNER: 'owner',
  APPROVER: 'approver',
  ACTION_OWNER: 'action-owner',
  ACTION_APPROVER: 'action-approver',
  WATCHER: 'watcher',
} as const;

export type Role = (typeof ROLE)[keyof typeof ROLE];
